import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { Ability } from '@casl/ability';
import { initialAbility } from '../rolesPolicy';

export const defaultValue = new Ability(initialAbility);
export const AbilityContext = createContext(defaultValue);
export const Can = createContextualCan(AbilityContext.Consumer);
